import { X } from 'lucide-react'
import { navigation } from '../../data/navigation'

interface MobileMenuProps {
    isOpen: boolean
    onClose: () => void
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
    if (!isOpen) return null

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                onClick={onClose}
            />

            {/* Drawer */}
            <div className="fixed top-0 right-0 h-full w-72 bg-white shadow-2xl z-50 lg:hidden transform transition-transform duration-300">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b">
                    <span className="text-lg font-bold text-dpxp-primary">Menu</span>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        aria-label="Fechar menu"
                    >
                        <X className="w-6 h-6 text-dpxp-dark" />
                    </button>
                </div>

                {/* Navigation Links */}
                <nav className="p-4">
                    <ul className="space-y-2">
                        {navigation.map((item) => (
                            <li key={item.href}>
                                <a
                                    href={`/${item.href}`}
                                    onClick={onClose}
                                    className="block px-4 py-3 text-dpxp-dark hover:bg-dpxp-primary/10 hover:text-dpxp-primary rounded-lg transition-colors font-medium"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>

                    {/* CTA Button - Logo após o menu */}
                    <a
                        href="/#contato"
                        onClick={onClose}
                        className="block w-full text-center mt-6 px-6 py-3 bg-dpxp-accent text-white font-semibold rounded-lg hover:bg-emerald-600 transition-colors"
                    >
                        Fale com um Especialista
                    </a>
                </nav>
            </div>
        </>
    )
}
